import ApiAbstract from './index'

class MockerApi extends ApiAbstract {
    static baseUri = `/`

    static load(mock = '', callback=null, execCallback=true) {
        return this.getProcess(mock, callback, execCallback, 200, true)
    }
}

export default MockerApi
